import styled from 'styled-components'

export const ModalFooter = styled.div`
  border-top: ${p => p.theme.modal.footerBorderTop};
  width: 100%;
  height: 56px;
  padding: 8px 24px 24px 24px;
  display: flex;
  justify-content: space-between;

  button {
    min-width: 96px;
  }
`

export const ModalBody = styled.div.attrs<{ className?: string }>(props => ({
  className: `px-40 pb-40 overflow-auto modal__form ${
    props.className || ''
  }`.trim(),
}))`
  height: calc(100vh / 2);
  overflow: auto;
`
export const styleMapHeight = {
  height: 'calc(100vh / 2 + 40px + 56px)',
}
